export default "__VITE_ASSET__BGfgVGUF__"